<template>
  <div
    v-analytics.pageview="'verification'"
    class="page page-verification"
  >
    <div class="verification">
      <div
        v-if="step === 1"
        class="verification-desc"
      >
        <div v-html="$t('p1_1')" />
        <p><br></p>
        <question
          v-if="step === 1"
          :item="regionOptions"
          :errors="errors[regionOptions.id]"
          @answer="onSelected"
        />
        <div v-html="$t('p1_2')" />
        <p><br></p>
        <question
          v-if="step === 1"
          :item="ageOptions"
          :errors="errors[ageOptions.id]"
          @answer="onSelected"
        />
      </div>
      <div
        v-if="step === 2"
        class="verification-desc"
        v-html="$t('p2', { REGION: region, AGE: age })"
      />
      <div
        v-if="step === 3"
        class="verification-desc"
        v-html="$t('p3')"
      />
      <div
        v-if="step === 4"
        class="verification-desc"
        v-html="$t('p4')"
      />
      <div
        v-if="step === 5"
        class="verification-desc"
        v-html="$t('p5')"
      />
      <div
        v-if="step === 6"
        class="verification-desc"
        v-html="$t('p6')"
      />
      <div
        v-if="step === 7"
        class="verification-desc"
        v-html="$t('p7')"
      />
      <div
        v-if="step === 8"
        class="verification-desc"
        v-html="$t('p8')"
      />
      <div
        v-if="step === 9"
        class="verification-desc"
        v-html="$t('p9')"
      />

      <div class="verification-btn-wrap">
        <b-button
          v-if="hasContinue"
          type="is-primary"
          class="verification-btn"
          @click="handleContinue"
        >
          {{ $t('continue') }}
        </b-button>
        <b-button
          v-if="hasExit"
          type="is-primary"
          class="verification-btn"
          @click="handleExit"
        >
          {{ $t('exit') }}
        </b-button>
        <b-button
          v-if="hasDisagree"
          type="is-primary"
          class="verification-btn"
          @click="handleDisagree"
        >
          {{ $t('disagree') }}
        </b-button>
        <b-button
          v-if="hasAgree"
          type="is-primary"
          class="verification-btn"
          @click="handleAgree"
        >
          {{ $t('agree') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash-es';
import { mapState } from 'vuex';
import { question } from '@/components';
import { getRegionList } from '@/apis/survey';
import EEAList from '@/configs/EEAList';
import { eventReport } from '@/apis/report';
import answerMixin from './answer/answer-mixin';
import { getAnswerHistoryCount } from './answer/answer-utils';

export default {
  name: 'Verification',
  components: {
    question,
  },
  mixins: [answerMixin],
  data() {
    const PrivacyPolicyUrl = 'https://mur-survey-out-1255655535.cos-website.ap-singapore.myqcloud.com/privacy-policy';
    const TermsOfServicesUrl = 'https://mur-survey-out-1255655535.cos-website.ap-singapore.myqcloud.com/eula/';
    let ageList = Array.from({ length: 38 }, (v, i) => i + 13);
    ageList = ageList.map((item) => {
      let age;
      if (item === 13) {
        age = { id: item.toString(), text: '13 or younger' };
      } else if (item === 50) {
        age = { id: item.toString(), text: '50 or older' };
      } else {
        age = { id: item.toString(), text: item.toString() };
      }
      return age;
    });
    return {
      step: 1,
      regionOptions: {
        id: 'region',
        title: '',
        type: 'select',
        options: [],
      },
      ageOptions: {
        id: 'age',
        title: '',
        type: 'select',
        options: ageList,
      },
      age: '',
      ageRestriction: null,
      region: '',
      isSkip: true,
      errors: {},
      PrivacyPolicyUrl,
      TermsOfServicesUrl,
    };
  },
  computed: {
    ...mapState([
      'configs', 'answers', 'surveyData',
    ]),
    hasContinue() {
      return [1].includes(this.step);
    },
    hasExit() {
      return [2, 3, 5, 7, 9].includes(this.step);
    },
    hasDisagree() {
      return [4, 6, 8].includes(this.step);
    },
    hasAgree() {
      return [4, 6, 8].includes(this.step);
    },
  },
  watch: {
    configs() {
      this.getRegionList();
    },

    hasExit(val) {
      if (val && !this.reported) {
        eventReport({
          type: 'event',
          category: 'abort',
          value: this.step,
        });
        this.reported = true;
      }
    },
  },
  created() {
    this.getRegionList();
  },
  methods: {
    async getRegionList() {
      if (isEmpty(this.configs) || !isEmpty(this.regionOptions.options)) {
        return;
      }
      const { outVerificationUseDefault, outVerificationRegions, outVerificationSkipWelcome } = this.configs;
      if (outVerificationSkipWelcome === undefined) {
        this.isSkip = true;
      } else {
        this.isSkip = outVerificationSkipWelcome;
      }
      if (outVerificationUseDefault || outVerificationUseDefault === undefined) {
        try {
          const regionList = await getRegionList();
          if (regionList) {
            this.regionOptions.options = regionList;
          }
        } catch (e) {
        }
      } else {
        this.regionOptions.options = outVerificationRegions;
      }
    },
    checkRules(age, ageRestriction) {
      if (ageRestriction) {
        return age >= ageRestriction;
      }
      return true;
    },
    onSelected({ questionId, values }) {
      const options = values.value;
      if (options && options.length > 0) {
        if (questionId === 'region') {
          const value = options[options.length - 1];
          this.region = value.id;
          this.ageRestriction = value.age;
        } else if (questionId === 'age') {
          const value = options[options.length - 1];
          this.age = value.id;
        }
      }
    },
    handleContinue() {
      this.errors = {};
      if (!this.region) {
        this.$set(this.errors, this.regionOptions.id, { questionErrMsg: 'Please choose' });
        return;
      }
      if (!this.age) {
        this.$set(this.errors, this.ageOptions.id, { questionErrMsg: 'Please choose' });
        return;
      }
      if (!this.checkRules(this.age, this.ageRestriction)) {
        if (this.region === 'United States') {
          // 美国验证不通过展示
          this.step += 2;
        } else {
          // 其他国家验证不通过展示
          this.step += 1;
        }
      } else if (EEAList.includes(this.region)) {
        this.step += 3;
      } else {
        this.step += 5;
      }
    },
    handleExit() {
      const { query } = this.$route;
      query.type = 'exit';
      this.$router.replace({ name: 'other', query });
    },
    handleAgree() {
      const { query } = this.$route;
      if (this.step !== 8) {
        this.step += 2;
      } else {
        window.sessionStorage.features = JSON.stringify({
          age: this.age,
          region: this.region,
        });

        const { isSaveAnswersHistory } = this.configs;
        if (isSaveAnswersHistory && getAnswerHistoryCount(this.answers) > 0) {
          this.routeReplace('answer-history', query, this.getSurveyLang(this.surveyData));
          return;
        }

        if (this.isSkip) {
          this.$router.replace({ name: 'answer', query });
        } else {
          this.$router.replace({ name: 'welcome', query });
        }
      }
    },
    handleDisagree() {
      this.step += 1;
    },
  },
};
</script>

<style lang="scss">
  .page-verification {
    padding: $padding $padding 0;
    background-color: #fff;
    min-height: 100vh;
    @include desktop {
      padding-top: 0;
      width: $desktopWidth;
      margin: 0 auto;
    }
    @include landscape {
      padding-top: 0;
      margin: 0 auto;
    }
  }
  .verification{
    font-size: $descSize;
    padding-bottom: 274px / $px;
    @include desktop {
      padding: $desktop-title-padding $desktop-title-padding 0;
    }
    @include landscape {
      padding: $landscape-title-padding $landscapePadding 0;
    }
    &-desc {
      @include desktop {
        margin-bottom: 30px / $px;
      }
      @include landscape {
         padding-bottom: 120px;
      }
      p {
        min-height: $padding;
      }
    }
    &-btn {
      margin-left: $padding;
      flex: 1;
      &-wrap {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        background-color: #fff;
        padding-top: 10px;
        padding-right: $padding;
        padding-bottom: 138px / $px;
        @include desktop {
          position: relative;
          margin-left: -24px;
          align-items: center;
          justify-content: center;
        }
        @include landscape {
          margin-left: -24px / $px;
          align-items: center;
          justify-content: center;
        }
      }
      @include desktop {
        flex: initial;
        min-width: 220px;
        margin: 0 0 0 24px / $px;
      }
      @include landscape {
        flex: initial;
        min-width: 220px;
        margin: 0 0 0 24px / $px;
      }
    }
    .question-title, .question-desc {
      display: none;
    }
  }
</style>
